module.exports = __webpack_public_path__ + "static/media/invest.4ec2b0dd.svg";